/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum GuideChannelOptionsOverlayActions {
    WATCH_NOW,
    FAVORITE_CHANNEL_ADD_REMOVE,
}

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum OneLineGuideChannelOptionsOverlayActions {
    WATCH_NOW,
    GO_TO_GRID_GUIDE,
    FAVORITE_CHANNEL_ADD_REMOVE,
}
